/**
 * Team colours (optional "Couleurs" display option): each team has one of these livery colours, picked by its owner.
 * `dark` shades the body, `light` is the main body colour. The game keeps working in 4 shades when the option is off.
 */
export interface TeamColor {
  name: string;
  dark: string;
  light: string;
}
export const TEAM_COLORS: TeamColor[] = [
  { name: "RED", dark: "#a8281f", light: "#f0604a" },
  { name: "BLUE", dark: "#2a54a8", light: "#6f9ae6" },
  { name: "YELLOW", dark: "#b88a10", light: "#f4d440" },
  { name: "GREEN", dark: "#27803a", light: "#6ccc60" },
  { name: "ORANGE", dark: "#b8561a", light: "#f89a3c" },
  { name: "PURPLE", dark: "#70349a", light: "#b884e0" },
  { name: "PINK", dark: "#b8447a", light: "#f294bc" },
  { name: "CYAN", dark: "#1c7e94", light: "#62d0e4" },
  { name: "WHITE", dark: "#8892a0", light: "#eef2f8" },
  { name: "BLACK", dark: "#1a2830", light: "#50686f" },
  { name: "BROWN", dark: "#6e4222", light: "#b88450" },
  { name: "LIME", dark: "#728f10", light: "#c8ec3c" },
];
export const TEAM_COLOR_COUNT = TEAM_COLORS.length;
/** Colour of a pilot without a team (rivals) and of the player's own car when they have none. */
export const NO_TEAM_RIVAL: TeamColor = { name: "-", dark: "#34408a", light: "#7c90d8" };
export const NO_TEAM_ME: TeamColor = TEAM_COLORS[0];
/** A valid colour index, or undefined. */
export const cleanTeamColor = (v: unknown): number | undefined => {
  const n = typeof v === "number" ? v : typeof v === "string" && v.trim() !== "" ? Number(v) : NaN;
  return Number.isInteger(n) && n >= 0 && n < TEAM_COLOR_COUNT ? n : undefined;
};
/** The colour of a team that never picked one: stable, from its tag. */
export const defaultTeamColor = (tag: string): number => {
  let h = 0;
  for (const ch of tag) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return h % TEAM_COLOR_COUNT;
};
